// extracted by mini-css-extract-plugin
module.exports = {"flex":"Logo_flex__3snYi","FontAwesome":"Logo_FontAwesome__302mw","siteName":"Logo_siteName__3zy7J"};